<template>
    <div class="w-full h-full overflow-hidden">
        <div class="h-full" v-if="typeof etapa == 'string'">
            <component :is="componente(etapa)" />
        </div>

        <div v-else-if="etapa.from && etapa.to" class="h-full overflow-hidden">
            <component ref="transitionOut" :is="componente(etapa.from)" :transition="etapa.transition + '-out'" />
            <component ref="transitionIn" :is="componente(etapa.to)" :transition="etapa.transition + '-in'" />
        </div>
    </div>
</template>

<style>
html {
    --animation-translate-x: 400px;
}

@keyframes right-to-left-out {
    0% {
        transform: translateX(0);
        opacity: 1;
    }

    100% {
        transform: translateX(var(--animation-translate-x));
        opacity: 0;
    }
}

.right-to-left-out {
    animation: right-to-left-out 0.3s;
}

@keyframes right-to-left-in {
    0% {
        transform: translateX(calc(var(--animation-translate-x) * -1));
        opacity: 0;
    }

    100% {
        transform: translateX(0px);
        opacity: 1;
    }
}

.right-to-left-in {
    position: absolute;
    top: 0;
    left: 0;
    animation: right-to-left-in 0.3s;
}

@keyframes left-to-right-out {
    0% {
        transform: translateX(0);
        opacity: 1;
    }

    100% {
        transform: translateX(calc(-1 * var(--animation-translate-x)));
        opacity: 0;
    }
}

.left-to-right-out {
    animation: left-to-right-out 0.3s;
}

@keyframes left-to-right-in {
    0% {
        transform: translateX(var(--animation-translate-x));
        opacity: 0;
    }

    100% {
        transform: translateX(0px);
        opacity: 1;
    }
}

.left-to-right-in {
    position: absolute;
    top: 0;
    left: 0;
    animation: left-to-right-in 0.3s;
}

@keyframes header-fade-out {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.header-fade-out {
    animation: header-fade-out 0.3s;
}

@keyframes header-fade-in {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.header-fade-in {
    animation: header-fade-in 0.3s;
}
</style>

<script>
import Conversa from './Conversa.vue'
import Convite from './Convite.vue'
import Identificação from './Identificação.vue'
import Home from './Home.vue'
import Search from './Search.vue'
import ReadQuestion from './ReadQuestion.vue'
import ThankYouAfterClose from './ThankYouAfterClose.vue'

export default {
    components: { Convite, Conversa, Identificação, Home, Search, ReadQuestion, ThankYouAfterClose },
    computed: {
        etapa() {
            return this.$store.state.etapa
        },
    },
    watch: {
        etapa(value) {
            if (typeof value === 'string') {
            } else if (value.from && value.to) {
                this.$nextTick(() => {
                    let elementIn = this.$el.querySelector('[data-transition-in]')
                    if (!elementIn) return

                    let elementOut = this.$el.querySelector('[data-transition-out]')
                    if (!elementOut) return

                    requestAnimationFrame(() => {
                        let rectIn = elementIn.getBoundingClientRect()
                        elementOut.style.height = rectIn.height + 'px'

                        let rectOut = elementOut.getBoundingClientRect()

                        document.documentElement.style.setProperty('--animation-translate-x', rectOut.width + 'px')

                        elementIn.style.width = rectOut.width + 'px'
                        elementIn.style.top = rectOut.top + 'px'
                        elementIn.style.left = rectOut.left + 'px'
                    })
                })
            }
        },
    },
    methods: {
        componente(etapa) {
            switch (etapa) {
                case 'convite':
                    return Convite
                case 'home':
                    return Home
                case 'identificação':
                    return Identificação
                case 'conversa':
                    return Conversa
                case 'search':
                    return Search
                case 'read_question':
                    return ReadQuestion
                case 'thank_you_after_close':
                    return ThankYouAfterClose
            }
        },
    },
}
</script>